import styled, { keyframes } from "styled-components";

export const ClientInfoWrapper = styled.div`
    min-height: 200px;
`;

export const ClientInfo = styled.div`
    display: flex;
    text-align: start;
    justify-content: flex-start;
    align-items: center;
`;

export const IconImg = styled.img`
    height: 15px;
    margin-right: 5px;
`;

export const OperationSentImage = styled.img`
    height: 150px;
    margin: auto auto 0;
`;

/**
 * ==============================================
 * Dot Flashing
 * ==============================================
 */
  
export const dotFlashing = keyframes`
  0% {
      background-color: #878786;
  }
  50%, 100% {
      background-color: rgb(0, 95, 63, 0.2);
  }
`;
export const DotFlashingWrapper = styled.div`
  width: 15px;
  display: flex;
  justify-content: end;
`;


export const DotFlashingDiv = styled.div`
  position: relative;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background-color: #878786;
  color: #878786;
  animation: ${dotFlashing} 1s infinite linear alternate;
  animation-delay: 0.5s;
  &:after {
    left: 7px;
    width: 5px;
    height: 5px;
    border-radius: 5px;
    background-color: #878786;
    color: #878786;
    animation: ${dotFlashing} 1s infinite alternate;
    animation-delay: 1s;
    content: "";
    display: inline-block;
    position: absolute;
    top: 0;
  }
  &:before {
    left: -7px;
    width: 5px;
    height: 5px;
    border-radius: 5px;
    background-color: #878786;
    color: #878786;
    animation: ${dotFlashing} 1s infinite alternate;
    animation-delay: 0s;
    content: "";
    display: inline-block;
    position: absolute;
    top: 0;
  }
`;